import {
  Accordion,
  AccordionActions,
  AccordionDetails,
  AccordionSummary,
  Avatar,
  Box,
  Button,
  Grid,
  Paper,
  Stack,
  Typography,
  Grow,
  Container,
  Badge,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import IconButton from "@mui/material/IconButton";
import { IoMdArrowDropdown } from "react-icons/io";
import "./Email.css";
import React, { useRef } from "react";
import parse from "html-react-parser";
import {
  ArrowBendDoubleUpLeft,
  ArrowBendUpLeft,
  ArrowBendUpRight,
  CaretDown,
  Check,
  CheckFat,
  Flag,
  Pencil,
} from "@phosphor-icons/react";
import moment from "moment";
import { connect } from "react-redux";
import {
  setShowEmailList,
  setselectedMail,
  setMailType,
  ApprovelEmail,
  listEmail,
} from "../../../../Redux/Actions/actions";
import {
  fileTypeToIconNeMail,
  formatFileSize,
} from "../../../Utils/Email-utils/email-utils";
import { useState } from "react";
import Popper from "@mui/material/Popper";
import MenuList from "@mui/material/MenuList";
import ClickAwayListener from "@mui/material/ClickAwayListener";

const LightTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: "#9E4CAF",
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#9E4CAF",
    color: "#FFFF",
    boxShadow: theme.shadows[1],
    fontSize: 11,
  },
}));
const BlueTooltip2 = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: "#0078d4",
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#0078d4",
    color: "#FFFF",
    boxShadow: theme.shadows[1],
    fontSize: 11,
  },
}));

const mapStateToProps = (state) => {
  return {
    showEmailList: state.email.showEmailList,
  };
};

const EmailBody = (props) => {
  const { mail, handleChange, expanded, preview } = props;
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedIndex, setSelectedIndex] = useState(1);
  const anchorRef = useRef([]);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const loggedInAgent = JSON.parse(localStorage.getItem("tokenAgent"));
  const emailBody = parse(mail.Email.emailBody, {
    replace: (domNode) => {
      if (
        domNode.type === "tag" &&
        domNode.name === "a" &&
        domNode.attribs.href
      ) {
        return (
          <a
            href={domNode.attribs.href}
            target="_blank"
            rel="noopener noreferrer"
          >
            {domNode.children[0].data}
          </a>
        );
      }
      return undefined;
    },
  });
  const [AttachmentPop, setAttachmentPop] = useState(
    Array(mail.Email.attachments.length).fill(false)
  );
  const handleToggle = (index) => {
    setAttachmentPop((prevOpenPoppers) =>
      prevOpenPoppers.map((isOpen, i) => (i === index ? !isOpen : isOpen))
    );
  };
  const sendhandleClose = (event, index) => {
    if (
      anchorRef.current[index] &&
      anchorRef.current[index].contains(event.target)
    ) {
      return;
    }

    setAttachmentPop((prevOpenPoppers) =>
      prevOpenPoppers.map((isOpen, i) => (i === index ? false : isOpen))
    );
  };
  const handleMenuItemClick = (index, options, data) => {
    setSelectedIndex(index);
    const newOpenPoppers = [...AttachmentPop];
    newOpenPoppers[index] = false;
    setAttachmentPop(newOpenPoppers);

    if (options == "Preview") {
      window.open(
        data.url,
        "_blank",
        "menubar=no,location=no,resizable=yes,scrollbars=yes,status=no,width=600,height=400"
      );
    } else {
      const link = document.createElement("a");
      link.href = data.url;
      link.setAttribute("download", data.filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  return (
    <Container
      sx={{ paddingLeft: "0 !important", paddingRight: "0 !important" }}
    >
      <Accordion
        className="mb-2"
        expanded={expanded === mail.Email._id}
        onChange={handleChange(mail.Email._id)}
        sx={{
          "&.MuiAccordion-root": {
            marginBottom: "2px",
            background:
              mail.Email.supervisorFlag && loggedInAgent.role == "Supervisor"
                ? "#ffa8a9"
                : "#FFFFF",
            width: preview ? "100%" : "none",
            fontSize: "13px",
          },
        }}
      >
        <AccordionSummary aria-controls="panel3-content" id="panel3-header">
          <Stack direction={"row"} spacing={1} sx={{ width: "100%" }}>
            {/* Avatar */}
            <Box>
              <Badge
                overlap="circular"
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                badgeContent={
                  expanded === mail.Email._id && (
                    <Avatar
                      className="box-inset2"
                      sx={{
                        background: "green",
                        fontWeight: 600,
                        fontSize: "14px",
                        width: "13px",
                        height: "13px",
                      }}
                    >
                      <CheckFat size={8} weight="fill" />
                    </Avatar>
                  )
                }
              >
                <Avatar
                  className="box-inset2"
                  sx={{
                    background: mail.Email.status == "Replied" ? "" : "#0B3363",
                    fontWeight: 600,
                    fontSize: "14px",
                  }}
                >
                  {mail.Email
                    ? mail.Email.fromList.slice(0, 2).toUpperCase()
                    : "UK"}
                </Avatar>
              </Badge>
            </Box>

            <Box sx={{ width: "100%" }}>
              <Stack
                sx={{ width: "100%" }}
                direction={"row"}
                justifyContent={"space-between"}
              >
                {/* mail from && subject content */}
                <Box
                  sx={{
                    width: "350px",
                  }}
                >
                  <Stack justifyContent={"flex-start"} spacing={1}>
                    {/* mail from */}
                    <Typography
                      variant="caption2"
                      sx={{ maxWidth: "300px" }}
                      noWrap
                    >
                      <h6 style={{ fontSize: "12px", marginBottom: "0" }}>
                        {mail.Email.fromList}
                      </h6>
                    </Typography>
                    {/* subject content */}
                    <Box
                      sx={{
                        overflowY:
                          expanded == mail.Email._id ? "scroll" : "hidden",
                      }}
                    >
                      {expanded == mail.Email._id ? (
                        <Stack spacing={0.5}>
                          {/* To */}
                          <Stack
                            direction={"row"}
                            alignItems={"center"}
                            spacing={0.5}
                          >
                            <Typography
                              sx={{
                                fontSize: "12px",
                              }}
                            >
                              To:
                            </Typography>
                            <Avatar
                              className="box-inset2"
                              sx={{
                                background: "green",
                                fontWeight: 600,
                                fontSize: "14px",
                                width: "13px",
                                height: "13px",
                              }}
                            >
                              <CheckFat size={8} weight="fill" />
                            </Avatar>
                            <Typography
                              sx={{
                                fontSize: "12px",
                              }}
                            >
                              {mail.Email.toList}
                            </Typography>
                          </Stack>
                          {/* Cc */}
                          {mail.Email.ccList.length > 0 && (
                            <Stack
                              direction={"row"}
                              alignItems={"center"}
                              spacing={0.5}
                            >
                              <Typography
                                sx={{
                                  fontSize: "12px",
                                }}
                              >
                                Cc:
                              </Typography>

                              {[
                                "sylvestermsc@imperiumapp.com",
                                "arangu@imperiumapp.com",
                                "Dhivanesh@imperiumapp.com",
                                "Bala@imperiumapp.com",
                              ].map((item) => {
                                if (item.emailAddress) {
                                  return (
                                    <>
                                      <Avatar
                                        className="box-inset2"
                                        sx={{
                                          background: "green",
                                          fontWeight: 600,
                                          fontSize: "14px",
                                          width: "13px",
                                          height: "13px",
                                        }}
                                      >
                                        <CheckFat size={8} weight="fill" />
                                      </Avatar>
                                      <Typography
                                        sx={{
                                          fontSize: "12px",
                                        }}
                                      >
                                        {item.emailAddress.address}
                                      </Typography>
                                    </>
                                  );
                                } else {
                                  return (
                                    <>
                                      <Avatar
                                        className="box-inset2"
                                        sx={{
                                          background: "green",
                                          fontWeight: 600,
                                          fontSize: "14px",
                                          width: "13px",
                                          height: "13px",
                                        }}
                                      >
                                        <CheckFat size={8} weight="fill" />
                                      </Avatar>
                                      <Typography
                                        sx={{
                                          fontSize: "12px",
                                        }}
                                      >
                                        {item}
                                      </Typography>
                                    </>
                                  );
                                }
                              })}
                            </Stack>
                          )}
                          {/* BCc */}
                          {mail.Email.bccList.length == 0 && (
                            <Stack
                              direction={"row"}
                              alignItems={"center"}
                              spacing={0.5}
                            >
                              <Typography
                                sx={{
                                  fontSize: "12px",
                                }}
                              >
                                BCc:
                              </Typography>

                              {[
                                "sylvestermsc@imperiumapp.com",
                                "arangu@imperiumapp.com",
                                "Dhivanesh@imperiumapp.com",
                                "Bala@imperiumapp.com",
                              ].map((item) => {
                                if (item.emailAddress) {
                                  return (
                                    <>
                                      <Avatar
                                        className="box-inset2"
                                        sx={{
                                          background: "green",
                                          fontWeight: 600,
                                          fontSize: "14px",
                                          width: "13px",
                                          height: "13px",
                                        }}
                                      >
                                        <CheckFat size={8} weight="fill" />
                                      </Avatar>
                                      <Typography
                                        sx={{
                                          fontSize: "12px",
                                        }}
                                      >
                                        {item.emailAddress.address}
                                      </Typography>
                                    </>
                                  );
                                } else {
                                  return (
                                    <>
                                      <Avatar
                                        className="box-inset2"
                                        sx={{
                                          background: "green",
                                          fontWeight: 600,
                                          fontSize: "14px",
                                          width: "13px",
                                          height: "13px",
                                        }}
                                      >
                                        <CheckFat size={8} weight="fill" />
                                      </Avatar>
                                      <Typography
                                        sx={{
                                          fontSize: "12px",
                                        }}
                                      >
                                        {item}
                                      </Typography>
                                    </>
                                  );
                                }
                              })}
                            </Stack>
                          )}
                        </Stack>
                      ) : (
                        <Typography
                          className="text-muted"
                          variant="h6"
                          sx={{
                            userSelect: "text",
                            maxWidth: "400px",
                            fontSize: "12px",
                            height:
                              expanded == mail.Email._id ? "50px" : "20px",
                          }}
                        >
                          {parse(mail.EmailBody)}
                        </Typography>
                      )}
                    </Box>
                  </Stack>
                </Box>
                {/* date && action button*/}
                <Box>
                  <Stack
                    alignItems={"center"}
                    sx={{ width: "100%", height: "100%" }}
                    justifyContent={"space-between"}
                  >
                    {props.action && (
                      <>
                        {/* action button */}
                        {expanded === mail.Email._id && (
                          <>
                            {loggedInAgent.role == "Supervisor" ? (
                              <>
                                {mail.Email.supervisorFlag ? (
                                  <Stack direction={"row"} spacing={0.5}>
                                    <LightTooltip
                                      title="Edit"
                                      arrow
                                      placement="top"
                                    >
                                      <IconButton
                                        onClick={() => {
                                          props.setShowEmailList(false);
                                          props.setMailType("Edit");
                                          props.setselectedMail(
                                            mail,
                                            props.index
                                          );
                                        }}
                                        id="edit-mail"
                                        sx={{
                                          ":hover": {
                                            borderRadius: "3px",
                                            background: "#9E4CAF40",
                                          },
                                          borderRadius: "3px",
                                        }}
                                      >
                                        <Pencil size={15} weight="fill" />
                                      </IconButton>
                                    </LightTooltip>
                                    <BlueTooltip2
                                      title="Approve Mail"
                                      arrow
                                      placement="top"
                                    >
                                      <IconButton
                                        sx={{
                                          ":hover": {
                                            borderRadius: "3px",
                                            background: "#0078d440",
                                          },
                                          borderRadius: "3px",
                                        }}
                                        id="approvel-mail"
                                        onClick={() => {
                                          props.ApprovelEmail({
                                            files: mail.Email.attachments,
                                            email: mail.Email.toList,
                                            subject: mail.Email.subject,
                                            ccData: mail.Email.ccList,
                                            bccData: mail.Email.bccList,
                                            html: mail.EmailBody,
                                            ticketID: mail.Email.ticketID,
                                            types: "Approve",
                                          });
                                        }}
                                      >
                                        <Flag size={15} weight="bold" />
                                      </IconButton>
                                    </BlueTooltip2>
                                  </Stack>
                                ) : (
                                  <Stack direction={"row"} spacing={0.5}>
                                    <LightTooltip
                                      title="Reply"
                                      arrow
                                      placement="top"
                                    >
                                      <IconButton
                                        sx={{
                                          ":hover": {
                                            borderRadius: "3px",
                                            background: "#9E4CAF40",
                                          },
                                          borderRadius: "3px",
                                        }}
                                        onClick={() => {
                                          props.setShowEmailList(false);
                                          props.setselectedMail(
                                            mail,
                                            props.index
                                          );
                                          props.setMailType("Replay");
                                        }}
                                        id="reply-mail"
                                      >
                                        <ArrowBendUpLeft
                                          size={17}
                                          weight="bold"
                                          color="#9E4CAF"
                                        />
                                      </IconButton>
                                    </LightTooltip>
                                    <LightTooltip
                                      title="Reply All"
                                      arrow
                                      placement="top"
                                    >
                                      <IconButton
                                        sx={{
                                          ":hover": {
                                            borderRadius: "3px",
                                            background: "#9E4CAF40",
                                          },
                                          borderRadius: "3px",
                                        }}
                                        onClick={() => {
                                          props.setShowEmailList(false);
                                          props.setMailType("ReplyAll");
                                          props.setselectedMail(
                                            mail,
                                            props.index
                                          );
                                        }}
                                        id="replay-all-mail"
                                      >
                                        <ArrowBendDoubleUpLeft
                                          size={17}
                                          weight="bold"
                                          color="#9E4CAF"
                                        />
                                      </IconButton>
                                    </LightTooltip>
                                    <BlueTooltip2
                                      title="Forward"
                                      arrow
                                      placement="top"
                                    >
                                      <IconButton
                                        sx={{
                                          ":hover": {
                                            borderRadius: "3px",
                                            background: "#0078d440",
                                          },
                                          borderRadius: "3px",
                                        }}
                                        onClick={() => {
                                          props.setShowEmailList(false);
                                          props.setMailType("Forward");
                                          props.setselectedMail(
                                            mail,
                                            props.index
                                          );
                                          props.listEmail(mail);
                                        }}
                                        id="forward-mail"
                                      >
                                        <ArrowBendUpRight
                                          size={17}
                                          weight="bold"
                                          color="#0078d4"
                                        />
                                      </IconButton>
                                    </BlueTooltip2>
                                  </Stack>
                                )}
                              </>
                            ) : (
                              <Stack direction={"row"} spacing={0.5}>
                                <LightTooltip
                                  title="Reply"
                                  arrow
                                  placement="top"
                                >
                                  <IconButton
                                    sx={{
                                      ":hover": {
                                        borderRadius: "3px",
                                        background: "#9E4CAF40",
                                      },
                                      borderRadius: "3px",
                                    }}
                                    onClick={() => {
                                      props.setShowEmailList(false);
                                      props.setselectedMail(mail, props.index);
                                      props.setMailType("Replay");
                                    }}
                                    id="reply-mail"
                                  >
                                    <ArrowBendUpLeft
                                      size={17}
                                      weight="bold"
                                      color="#9E4CAF"
                                    />
                                  </IconButton>
                                </LightTooltip>
                                <LightTooltip
                                  title="Reply All"
                                  arrow
                                  placement="top"
                                >
                                  <IconButton
                                    sx={{
                                      ":hover": {
                                        borderRadius: "3px",
                                        background: "#9E4CAF40",
                                      },
                                      borderRadius: "3px",
                                    }}
                                    onClick={() => {
                                      props.setShowEmailList(false);
                                      props.setMailType("ReplyAll");
                                      props.setselectedMail(mail, props.index);
                                    }}
                                    id="replay-all-mail"
                                  >
                                    <ArrowBendDoubleUpLeft
                                      size={17}
                                      weight="bold"
                                      color="#9E4CAF"
                                    />
                                  </IconButton>
                                </LightTooltip>
                                <BlueTooltip2
                                  title="Forward"
                                  arrow
                                  placement="top"
                                >
                                  <IconButton
                                    sx={{
                                      ":hover": {
                                        borderRadius: "3px",
                                        background: "#0078d440",
                                      },
                                      borderRadius: "3px",
                                    }}
                                    onClick={() => {
                                      props.setShowEmailList(false);
                                      props.setMailType("Forward");
                                      props.setselectedMail(mail, props.index);
                                      props.listEmail(mail);
                                    }}
                                    id="forward-mail"
                                  >
                                    <ArrowBendUpRight
                                      size={17}
                                      weight="bold"
                                      color="#0078d4"
                                    />
                                  </IconButton>
                                </BlueTooltip2>
                              </Stack>
                            )}
                          </>
                        )}
                      </>
                    )}
                    {/* mail arrival date */}
                    <Typography
                      variant="h6"
                      className="text-muted"
                      sx={{
                        userSelect: "text",
                        maxWidth: "150px",
                        fontSize: "12px",
                      }}
                    >
                      {moment(mail.Email.createdAt).format(
                        "ddd M/D/YYYY h:mm A"
                      )}
                    </Typography>
                  </Stack>
                </Box>
              </Stack>
            </Box>
          </Stack>
        </AccordionSummary>

        <AccordionDetails>
          <Stack spacing={1} className="p-2 mb-2" sx={{ background: "white" }}>
            {mail.Email.attachments.length > 0 && (
              <Grid xs={12} item>
                <Grid container direction="row">
                  <Grid md={2} sm={2} item>
                    <Button
                      variant="outlined"
                      disableRipple
                      sx={{
                        padding: "0px 3px",
                        minWidth: "max-content",
                        borderRadius: "0px",
                        borderColor: "gray",
                        border: "none",
                        textTransform: "none",
                        fontSize: "12px",
                        color: "#7a7a7a",
                        cursor: "default !important",
                        "&:hover": {
                          border: "none",
                          background: "none",
                        },
                      }}
                    >
                      Attachment
                    </Button>
                  </Grid>

                  <Grid md={10} sm={10} item>
                    <div className="attachment-container">
                      {mail.Email.attachments.length > 0
                        ? mail.Email.attachments.map((data, index) => {
                            const icon = fileTypeToIconNeMail[data.extension];
                            return (
                              <Box
                                sx={{
                                  width: "max-content",
                                  border: "1px solid #cfcfcf",
                                  padding: "5px",
                                  fontSize: "13px",
                                }}
                                key={index}
                              >
                                <Stack
                                  direction={"row"}
                                  alignItems={"center"}
                                  spacing={0.5}
                                >
                                  <img
                                    src={icon}
                                    alt="File Icon"
                                    width="20px"
                                    height="20px"
                                  />
                                  <Stack spacing={0.4}>
                                    <Typography
                                      variant="caption"
                                      noWrap
                                      sx={{ width: "100px", fontSize: "13px" }}
                                    >
                                      <a href=""></a>
                                      {data.filename}
                                    </Typography>
                                    <div className="file-size">
                                      {formatFileSize(data.filesize)}
                                    </div>
                                  </Stack>
                                  <div className="dropdown-icon">
                                    <CaretDown
                                      color="#b2b2b2"
                                      ref={(el) =>
                                        (anchorRef.current[index] = el)
                                      }
                                      aria-controls={
                                        AttachmentPop[index]
                                          ? "split-button-menu"
                                          : undefined
                                      }
                                      aria-expanded={
                                        AttachmentPop[index]
                                          ? "true"
                                          : undefined
                                      }
                                      aria-label="select merge strategy"
                                      aria-haspopup="menu"
                                      onClick={() => handleToggle(index)}
                                      className={
                                        AttachmentPop[index]
                                          ? "rotate-90"
                                          : "rotate-0"
                                      }
                                    />

                                    <Popper
                                      sx={{
                                        zIndex: 1,
                                        marginTop: "10px !important",
                                      }}
                                      open={AttachmentPop[index]}
                                      anchorEl={anchorRef.current[index]}
                                      role={undefined}
                                      transition
                                      disablePortal
                                    >
                                      {({ TransitionProps, placement }) => (
                                        <Grow
                                          {...TransitionProps}
                                          style={{
                                            transformOrigin:
                                              placement === "bottom"
                                                ? "center top"
                                                : "center bottom",
                                          }}
                                        >
                                          <Paper sx={{ borderRadius: "0px" }}>
                                            <ClickAwayListener
                                              onClickAway={(event) =>
                                                sendhandleClose(event, index)
                                              }
                                            >
                                              <MenuList
                                                id="split-button-menu"
                                                autoFocusItem
                                                sx={{
                                                  paddingTop: "0px",
                                                  paddingBottom: "0px",
                                                }}
                                              >
                                                {["Preview", "Download"].map(
                                                  (item, ind) => (
                                                    <MenuItem
                                                      sx={{
                                                        paddingLeft: "10px",
                                                        paddingRight: "40px",
                                                        fontSize: "12px",
                                                      }}
                                                      key={ind}
                                                      disabled={ind === 2}
                                                      selected={
                                                        ind === selectedIndex
                                                      }
                                                      onClick={(event) =>
                                                        handleMenuItemClick(
                                                          ind,
                                                          item,
                                                          data
                                                        )
                                                      }
                                                    >
                                                      {item}
                                                    </MenuItem>
                                                  )
                                                )}
                                              </MenuList>
                                            </ClickAwayListener>
                                          </Paper>
                                        </Grow>
                                      )}
                                    </Popper>
                                  </div>
                                </Stack>
                              </Box>
                            );
                          })
                        : null}
                    </div>
                  </Grid>
                </Grid>
              </Grid>
            )}
            {emailBody}
          </Stack>
        </AccordionDetails>
      </Accordion>
    </Container>
  );
};
export default connect(mapStateToProps, {
  setShowEmailList,
  setselectedMail,
  setMailType,
  ApprovelEmail,
  listEmail,
})(EmailBody);
